import { Spacing } from '@persona-id/design-tokens';
import { snakeCase } from 'lodash/fp';
import { UseFormReturn } from 'react-hook-form';
import styled from 'styled-components';

import { ClassificationPanelForm } from 'dashboard/components/ClassificationsConfig/util';
import { TextAreaField, TextField } from 'design-system/components/FormField';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';
import Tooltip from 'design-system/components/Tooltip';

const Section = styled.section`
  padding: ${Spacing[4]};
`;

const Seperator = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.color.border.primary};
`;

// TODO: [Documents] Migrate to PDS component for underline tooltip indicators when available
const TooltipIndicatorWrapper = styled.div`
  width: fit-content;
  text-decoration: underline;
  text-decoration-style: dotted;
`;

interface ClassificationPanelContentProps {
  formReturn: UseFormReturn<ClassificationPanelForm>;
}

const ClassificationPanelContent = ({ formReturn }: ClassificationPanelContentProps) => {
  const { register, formState, setValue, trigger } = formReturn;
  const { errors } = formState;

  return (
    <>
      <Section>
        <TextField
          {...register('label', {
            onChange: (e) => {
              setValue('key', snakeCase(e.target.value));
              trigger('key');
            },
          })}
          label={
            <Tooltip
              side='right'
              trigger={<TooltipIndicatorWrapper>Label</TooltipIndicatorWrapper>}
            >
              <Paragraph>
                Specify a label that clearly identifies the document type. This label is used as the
                primary identifier of this document type.
              </Paragraph>
            </Tooltip>
          }
          placeholder='Enter label'
          errorText={errors?.label?.message}
          autoFocus
        />
        <TextField {...register('key')} label='Key' errorText={errors?.key?.message} disabled />
      </Section>
      <Seperator />
      <Section>
        <Paragraph weight='bold' color='primary'>
          Configure
        </Paragraph>
        <Spacer height={1.5} />
        <TextAreaField
          {...register('description', { setValueAs: (value: string) => value.trim() })}
          label={
            <Tooltip
              side='top'
              trigger={
                <TooltipIndicatorWrapper>
                  Additional instructions (optional)
                </TooltipIndicatorWrapper>
              }
            >
              <Paragraph>Optionally provide additional details of this document type.</Paragraph>
            </Tooltip>
          }
          placeholder='Enter additional instructions'
          errorText={errors?.description?.message}
          style={{ resize: 'vertical' }}
        />
      </Section>
    </>
  );
};

export default ClassificationPanelContent;
